import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SVGIconWithSizes;

import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconPlayFill', new SVGIconWithSizes((_SVGIconWithSizes = {}, _defineProperty(_SVGIconWithSizes, IconSize.ExtraSmall, {
  paths: ['M15 8C15 8.34562 14.8215 8.66674 14.528 8.84923L4.77802 14.9114C4.46966 15.1031 4.0816 15.1126 3.76421 14.9363C3.44683 14.7599 3.25 14.4253 3.25 14.0622L3.25 1.93782C3.25 1.57471 3.44683 1.24014 3.76421 1.06374C4.0816 0.88735 4.46966 0.89686 4.77802 1.08859L14.528 7.15077C14.8215 7.33326 15 7.65438 15 8Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), _defineProperty(_SVGIconWithSizes, IconSize.Small, {
  paths: ['M17 10C17 10.4405 16.7722 10.8497 16.3975 11.0823L3.95066 18.8079C3.55701 19.0522 3.06161 19.0643 2.65644 18.8395C2.25127 18.6147 2 18.1883 2 17.7256L2 2.27439C2 1.81165 2.25127 1.38527 2.65644 1.16048C3.06161 0.935681 3.55701 0.947801 3.95067 1.19214L16.3975 8.91774C16.7722 9.15031 17 9.55954 17 10Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), _defineProperty(_SVGIconWithSizes, IconSize.Medium, {
  paths: ['M22 12C22 12.5383 21.7266 13.0385 21.277 13.3228L6.3408 22.7652C5.86841 23.0638 5.27394 23.0786 4.78773 22.8039C4.30152 22.5291 4 22.008 4 21.4424L4 2.55759C4 1.99202 4.30153 1.47089 4.78773 1.19614C5.27394 0.921388 5.86841 0.936201 6.3408 1.23484L21.277 10.6772C21.7266 10.9615 22 11.4617 22 12Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), _defineProperty(_SVGIconWithSizes, IconSize.Large, {
  paths: ['M29 15.5C29 16.2096 28.6355 16.8689 28.036 17.2436L8.12106 29.6904C7.49121 30.0841 6.69858 30.1036 6.05031 29.7415C5.40203 29.3793 5 28.6923 5 27.9468L5 3.05319C5 2.30766 5.40203 1.62071 6.05031 1.25854C6.69858 0.896375 7.49122 0.915901 8.12106 1.30956L28.036 13.7564C28.6355 14.1311 29 14.7904 29 15.5Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));